import script from "./StoresView.vue?vue&type=script&lang=ts&setup=true"
export * from "./StoresView.vue?vue&type=script&lang=ts&setup=true"

import "./StoresView.vue?vue&type=style&index=0&id=7b7c8f46&lang=scss"

const __exports__ = script;

export default __exports__